import { render, staticRenderFns } from "./DepartmentPage.vue?vue&type=template&id=5692f6ec&"
import script from "./DepartmentPage.vue?vue&type=script&lang=js&"
export * from "./DepartmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports